__turbopack_context__.v({
  "caption": "ctagroup-module-scss-module__KMgzgG__caption",
  "ctaGroup": "ctagroup-module-scss-module__KMgzgG__ctaGroup",
  "desktopCenter": "ctagroup-module-scss-module__KMgzgG__desktopCenter",
  "mainButtons": "ctagroup-module-scss-module__KMgzgG__mainButtons",
  "mobileLeft": "ctagroup-module-scss-module__KMgzgG__mobileLeft",
  "tertiary": "ctagroup-module-scss-module__KMgzgG__tertiary",
});
